<template>
    <FilterableMultiSelect
        :model-value="value"
        :options="options"
        :placeholder="placeholder"
        :label="label"
        :description-id="descriptionId"
        :disabled="!!disabled"
        :required="required"
        :error-message="errorMessage"
        :multi-select="multiselect"
        :hide-selected-badges="hideSelectedBadges"
        :sheet-title="sheetTitle"
        :action-label="actionLabel"
        @update:model-value="emit('update', $event)"
        @action="emit('action')"
    />
</template>

<script setup lang="ts">
import type { Option } from '@/stores/store-interfaces';

import FilterableMultiSelect from '@/components/ui/select/FilterableMultiSelect.vue';

defineProps({
    value: {
        type: Array as () => Option[],
        required: true,
    },
    placeholder: {
        type: String,
        default: 'Select',
    },
    options: {
        type: Array as () => Option[],
        required: true,
    },
    label: {
        type: String,
        required: true,
    },
    descriptionId: {
        type: String,
        required: false,
    },
    required: {
        type: Boolean,
        default: false,
    },
    multiselect: {
        type: Boolean,
        default: false,
    },
    uniqueKey: {
        // deprecated, no longer needed
        type: Number,
        required: false,
    },
    errorMessage: {
        type: String,
        required: false,
    },
    disabled: {
        type: Boolean,
        required: false,
    },
    hideSelectedBadges: {
        type: Boolean,
        required: false,
    },
    /**
     * Title for the mobile sheet header. For callers whose visible label is
     * empty (the notifications org picker) the sheet would otherwise fall
     * back to a generic "Select an option".
     */
    sheetTitle: {
        type: String,
        required: false,
    },
    /** Pinned first-row action (e.g. "Create new visitor"); emits `action` when chosen. */
    actionLabel: {
        type: String,
        required: false,
    },
});
const emit = defineEmits(['update', 'action']);
</script>
